module.exports = __webpack_public_path__ + "img/圆角矩形 3 拷贝 2@2x.53497fb6.png";